import { Star } from "lucide-react";

export const STATUS_LABELS = {
  aguardando_indicacao: "Aguardando indicação",
  aguardando_orcamento: "Aguardando orçamento",
  orcamento_enviado: "Orçamento enviado",
  agendado: "Agendado",
  em_execucao: "Em execução",
  concluido: "Concluído",
  cancelado: "Cancelado",
  encerrado: "Encerrado",
  bloqueado: "Bloqueado",
  novo: "Novo",
  em_contato: "Em contato",
  parceria_fechada: "Parceria fechada",
  finalizado: "Finalizado",
  recusado: "Recusado",
};

export const PARTNER_STAGES = ["novo", "em_contato", "parceria_fechada", "finalizado"];

export const STAGE_ORDER = [
  "aguardando_indicacao",
  "aguardando_orcamento",
  "orcamento_enviado",
  "agendado",
  "em_execucao",
  "concluido",
  "cancelado",
  "encerrado",
];

export const STATUS_COLORS = {
  aguardando_indicacao: "bg-orange-100 text-orange-700",
  aguardando_orcamento: "bg-amber-100 text-amber-700",
  orcamento_enviado: "bg-blue-100 text-blue-700",
  agendado: "bg-violet-100 text-violet-700",
  em_execucao: "bg-cyan-100 text-cyan-700",
  concluido: "bg-emerald-100 text-emerald-700",
  cancelado: "bg-red-100 text-red-600",
  encerrado: "bg-slate-100 text-slate-500",
  bloqueado: "bg-red-600 text-white",
  novo: "bg-orange-100 text-orange-700",
  em_contato: "bg-amber-100 text-amber-700",
  parceria_fechada: "bg-emerald-100 text-emerald-700",
  finalizado: "bg-slate-100 text-slate-500",
  recusado: "bg-rose-100 text-rose-600",
};

export const statusLabel = (s) => STATUS_LABELS[s] || s;
export const statusColor = (s) => STATUS_COLORS[s] || "bg-slate-100 text-slate-500";

export const STAGE_DOTS = {
  aguardando_indicacao: "#FF5C00",
  aguardando_orcamento: "#F59E0B",
  orcamento_enviado: "#3D8BFF",
  agendado: "#8B5CF6",
  em_execucao: "#06B6D4",
  concluido: "#10B981",
  cancelado: "#EF4444",
  encerrado: "#64748B",
};

export const TYPE_META = {
  service: { label: "Atendimento", classes: "bg-brand/10 text-brand" },
  partner: { label: "Parceiro", classes: "bg-violet-100 text-violet-700" },
  agency: { label: "Imobiliária", classes: "bg-emerald-100 text-emerald-700" },
};

export const PRIORITY_COLORS = {
  Urgente: "bg-red-100 text-red-700",
  Média: "bg-amber-100 text-amber-700",
  Baixa: "bg-slate-100 text-slate-600",
};

export const PAYLOAD_LABELS = {
  company: "Imobiliária",
  name: "Nome",
  phone: "Telefone",
  email: "E-mail",
  profile: "Perfil",
  priority: "Prioridade",
  city: "Cidade",
  address: "Endereço",
  agency_name: "Imobiliária (locatário)",
  schedule: "Disponibilidade para visita",
  message: "Mensagem",
  document: "CNPJ/CPF",
  experience: "Experiência",
  state: "Estado",
  cities: "Cidades atendidas",
  specialties: "Serviços prestados",
  specialty: "Especialidade",
  regions: "Regiões atendidas",
};

export const EDITABLE_KEYS = new Set([
  "name",
  "company",
  "phone",
  "email",
  "city",
  "address",
  "agency_name",
  "message",
  "document",
  "experience",
  "cities",
  "specialties",
]);

export const ARRAY_EDIT_KEYS = new Set(["cities", "specialties"]);

export const renderValue = (v) => {
  if (Array.isArray(v)) {
    if (v.length > 0 && typeof v[0] === "object") {
      return v
        .map((s) => `${String(s.date).split("-").reverse().join("/")} às ${s.time}`)
        .join("   •   ");
    }
    return v.join(", ");
  }
  return v;
};

export const displayName = (lead) =>
  lead.type === "agency" ? lead.payload?.company : lead.payload?.name;

export const metaLine = (lead) => {
  const p = lead.payload || {};
  const parts = [];
  if (lead.type === "service") parts.push(p.city, p.profile);
  if (lead.type === "partner") parts.push((p.cities || []).slice(0, 3).join(", "), p.state);
  if (lead.type === "agency") parts.push(p.name, p.phone);
  parts.push(
    new Date(lead.created_at).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" })
  );
  return parts.filter(Boolean).join("  ·  ");
};

export const Badge = ({ className, children, testId }) => (
  <span
    data-testid={testId}
    className={`rounded-full px-2.5 py-0.5 text-[0.65rem] font-semibold uppercase tracking-wider ${className}`}
  >
    {children}
  </span>
);

export const Stars = ({ value = 0, className = "h-3.5 w-3.5" }) => (
  <span className="inline-flex items-center gap-0.5" data-testid="stars">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star
        key={n}
        className={`${className} ${n <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"}`}
      />
    ))}
  </span>
);
